import api from '../../../services/ApiConfig';
import { Apis } from '../../../config';
import { NotificationManager } from 'react-notifications';
import { eraseCookie, setCookie } from '../../../function';

const getUserLogin = async (data) => {
    try {
        const result = await api.post(Apis.GetUserLogin, data, {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });

        console.log("result" , result)
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        const responseData = JSON.parse(result.data);
        let parsedData = JSON.parse(responseData.body);
        // 
        return parsedData.additionalData;
    } catch (error) {
        console.error('Error in getUserLogin:', error);
        NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};
const authenticate = (data, next) => {
    if (typeof window !== "undefined") {
        console.log("Setting cookies for token:", data.token);
        setCookie('token', data.token, 3000);
        setCookie('role', data.user.userType, 3000);
        setCookie('id', data.user.id, 3000);
        next();
    }
};

const logout = (next) => {
    if (typeof window !== "undefined") {
        eraseCookie('token');
        eraseCookie('role');
        eraseCookie('XSRF-token');
        window.location.reload();
        // Optionally redirect or call next() after logout
        // window.location.href = "/auth/login";
        // next();
    }
};
export default {
    getUserLogin,
    authenticate,
    logout
};